import { sizeChartConstants } from "../../constants";

export function sizeCharts(state = {}, action) {
  switch (action.type) {
    // get all
    case sizeChartConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case sizeChartConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case sizeChartConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case sizeChartConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case sizeChartConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sizeChartConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case sizeChartConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case sizeChartConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sizeChartConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case sizeChartConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case sizeChartConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sizeChartConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case sizeChartConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
